import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ScreenLoaderComponent } from './shared/components/loader/screen-loader.component';
import { Observable } from 'rxjs';
import { APPLICATION_REDUCER } from './store/reducers/application.reducer';
import { AsyncPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ConversationDetailsComponent } from './components/conversation-data/components/conversation-details/conversation-details.component';
import { ConversationDataComponent } from './components/conversation-data/conversation-data.component';

@Component({
  selector: 'cv-root',
  standalone: true,
  imports: [
    ConfirmDialogModule,
    ScreenLoaderComponent,
    AsyncPipe,
    RouterOutlet,
    ToastModule,
    ConversationDetailsComponent,
    ConversationDataComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  isLoading$: Observable<boolean> = this.store.select(APPLICATION_REDUCER.selectLoading);

  constructor(private readonly store: Store) {}
}
